import {Component} from "@angular/core";
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'my-account-tabs',
	templateUrl: './my-account-tabs.component.html',
})
export class MyAccountTabsComponent extends TabsPageContainer {
	tabs = this.dic.CONSTANTS.myProfilePageTabs;
}
